import calculateIndexMap from "./calculateIndexMap";
import calculateIndexMap2 from "./calculateIndexMap2";

/*
This function will split the array into `n` (number of columns) parts.
*/
const splitArrayRole = (items, options) => {
  const n = Math.floor(items.length / options.columns);
  const extra = items.length - n * options.columns;

  let middle = options.columns % 2 === 0 ? (options.columns / 2) + 1 : Math.ceil(options.columns / 2);
  if (options.columns === 2) {
    middle = 1;
  }

  const indexMap = options.balance_columns ? calculateIndexMap(extra, middle) : calculateIndexMap2(extra, middle);

  let arr = [...items];
  let res = [];
  let i = 1;

  // Split items into rows based on columns
  while (arr.length) {
    if (indexMap[i] === true) {
      res.push(arr.splice(0, n + 1));
      i = i + 1;
    } else {
      res.push(arr.splice(0, n));
      i = i + 1;
    }
  }

  // Adjust second column to start with a "role" item and keep "no roll" items in place after the first "role" item
  if (options.columns === 2) {
    let adjustedRes = [];
    const firstColumn = res[0] || [];
    const secondColumn = res[1] || [];

    // Check if the first item in the second column has a role
    if (secondColumn.length && secondColumn[0].role === undefined) {
      let roleFound = false;
      let newSecondColumn = [];

      for (let item of secondColumn) {
        if (!roleFound && item.role === undefined) {
          // Move "no roll" items from the start of the second column to the first column until a "role" item is found
          firstColumn.push(item);
        } else {
          // Keep all items in the second column after the first "role" item is found
          newSecondColumn.push(item);
          if (item.role !== undefined) {
            roleFound = true; // Role item found, subsequent "no roll" items should remain in column 2
          }
        }
      }

      adjustedRes.push(firstColumn);
      adjustedRes.push(newSecondColumn);
    } else {
      // If the second column starts correctly with a role item, keep as is
      adjustedRes.push(firstColumn);
      adjustedRes.push(secondColumn);
    }

    res = adjustedRes;
  }

  let ans = res;
  return { ans, indexMap };
};

export default splitArrayRole;
